
import { Component, ObjectManager } from '../../../concepts/objects';
import { EditorSession } from '../../canvas/EditorSession';
import { MyProfileInfo } from '../../canvas/MyProfileInfo';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { ActiveObject, resolve } from '../../Container';
import { CreatedIncognitoAttr } from '../incognito/IncognitoAssociations';
import { Audited } from './Audited';

export class AuditingMechanics extends ActiveObject {

    @resolve(EditorSession) session!: EditorSession;
    @resolve(ObjectManager) objects!: ObjectManager;
    @resolve(WidgetManager) widgets!: WidgetManager;

    public start = () => this.burden(
        this.objects.createTrigger('Auditing.SetProps', { priority: true })
            .forAllTypes().onCreated().do(this.setAuditedPropsFor)
    );

    private setAuditedPropsFor = (elmts: Iterable<Component>) => {
        const now = new Date();
        const me = this.session.get(MyProfileInfo).id;
        for (const e of elmts) {
            const a = e.as(Audited);
            if (!a) continue;
            if (!a.created) a.created = now;
            if (!a.userId && !CreatedIncognitoAttr.get(a)) a.userId = me;
        }
    };
}
